import { memo } from 'react';
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import { Text, TextBlock } from '@library';
import VerticalLayout from '../layout/VerticalLayout';
import styles from './TableCellText.module.scss';

const TableCellText = ({
    children,
    emphasized = false,
    noWrap = false,
    ...ariaProps
}: {
    children: ReactNode;
    emphasized?: boolean;
    noWrap?: boolean;
}) => (
    <div
        className={clsx(styles.cellPrimaryText, {
            [styles.cellPrimaryTextNoWrap]: noWrap,
        })}
        {...ariaProps}
    >
        <TextBlock secondary regular={!emphasized} medium={emphasized}>
            {children}
        </TextBlock>
    </div>
);

export const TableCellTextWithSubtext = memo(
    ({
        text,
        subText,
        emphasized = false,
    }: {
        text?: ReactNode;
        subText?: ReactNode;
        emphasized?: boolean;
    }) => {
        if (subText) {
            return (
                <VerticalLayout justify="center" stretchChildren>
                    <div className={styles.cellPrimaryText}>
                        <TextBlock
                            secondary
                            regular={!emphasized}
                            medium={emphasized}
                        >
                            {text}
                        </TextBlock>
                    </div>
                    <div className={styles.cellSecondaryText}>
                        <Text caption regular>
                            {subText}
                        </Text>
                    </div>
                </VerticalLayout>
            );
        }

        return (
            <div className={styles.cellPrimaryText}>
                <TextBlock secondary regular={!emphasized} medium={emphasized}>
                    {text}
                </TextBlock>
            </div>
        );
    }
);

/**
 * @deprecated
 * Please use `TableCellText` from `@library`
 */
export default memo(TableCellText);
